/**
 * @author PengWen
 * @description 新能源组织迁移  业务数据的受众/管理范围调整
 * @Date 2023/03/20
 */
import React from "react";
import { connect } from "dva";
import { framework_tool } from '../../../tool';
import { templateConfig, reduxTemplateConfig } from "./config";

let { WizContainer, WizReduxTemplate } = framework_tool;

class BizDataMoveManager extends WizContainer {
    componentName = 'BizDataMoveManager';

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    _handleCMD(nextProps, nextState, key){
        let o = nextProps[key];
        if (o['success']) {
          wizNotice.success(o['msg']);
          return true;
        } else {
          wizNotice.error(o['msg']);
          return false;
        }
    }

    _render() {
        let _reduxTemplateConfig = reduxTemplateConfig({
          templateConfig,
          apiDataFormat: {},
        })
        return <WizReduxTemplate {..._reduxTemplateConfig} />
    }
    
    
}

const mapStateToProps = (state, ownProps) => {
    return {
    }
};
  
export default connect(mapStateToProps)(BizDataMoveManager);
